import { PAGE_TYPE_HOMEPAGE } from 'shared/consts'
import { CSW_PRODUCT_CLICK, HOME_THIRD_CSW } from 'shared/experiments/consts'
import { event } from 'shared/experiments/utils/event'
import {
  activateExperiment,
  getExperiments,
} from 'shared/experiments/utils/experiments'
import { bindDynamicEventsTracking } from 'shared/experiments/utils/tracking'
import store from 'shared/store'

export default async () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType, experiments } = publicRuntimeConfig?.pageProperties || {}
  const [homeThirdCswExperiment] = getExperiments([HOME_THIRD_CSW], experiments)

  if (!homeThirdCswExperiment?.isEnabled) {
    return
  }

  await activateExperiment(HOME_THIRD_CSW)

  if (pageType === PAGE_TYPE_HOMEPAGE) {
    bindDynamicEventsTracking([
      {
        parentElementSelector: '[data-clientside-api-call="fetchCrossSell"]',
        selector:
          '[data-crosssell-id="329"] [data-clientside-hook~=slider__item]',
        trackingEvent: event`${CSW_PRODUCT_CLICK} 329`,
      },
      {
        parentElementSelector: '[data-clientside-api-call="fetchCrossSell"]',
        selector:
          '[data-crosssell-id="299"] [data-clientside-hook~=slider__item]',
        trackingEvent: event`${CSW_PRODUCT_CLICK} 299`,
      },
    ])
  }
}
